import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	feedbackButton: {
		id: 'feedback_button',
		defaultMessage: 'Give feedback',
		description: 'Click this button to give feedback for search.',
	},
});
